import React from 'react'

import VerticalMenu from '@components/vertical-menu/VerticalMenu'
import SearchBar from '@components/search-bar/SearchBar'

import './Layout.css'

interface LayoutProps {
	/** Show the vertical navigation menu (defaults to true). */
	showNav?: boolean
	/** Show the search bar in the header (defaults to true). */
	showSearchBar?: boolean
	/** Current search bar value (when the page drives the search). */
	searchValue?: string
	/** Called on every keystroke in the search bar. */
	onSearchChange?: (value: string) => void
	/** Called when the search is submitted (Enter / button click). */
	onSearchSubmit?: (value: string) => void
	/** Page-specific header content rendered below the search bar (e.g. a title). */
	headerContent?: React.ReactNode
	/** Extra class name applied to the layout wrapper. */
	className?: string
	children: React.ReactNode
}

// Layout is the shared page chrome (vertical menu, logo, search bar) so that the
// form and form-admin pages stay visually consistent. Only `children` changes
// between pages.
function Layout({
	showNav = true,
	showSearchBar = true,
	searchValue,
	onSearchChange,
	onSearchSubmit,
	headerContent,
	className,
	children,
}: LayoutProps) {
	const wrapperClass = [
		'layout',
		showNav ? 'layout--with-nav' : '',
		className ?? '',
	]
		.filter(Boolean)
		.join(' ')

	return (
		<div className={wrapperClass}>
			{showNav && <VerticalMenu />}
			<div className='layoutMain'>
				<header className='layoutHeader'>
					<div className='layoutLogo' />
					{showSearchBar && (
						<SearchBar
							value={searchValue}
							onChange={onSearchChange}
							onSubmit={onSearchSubmit}
						/>
					)}
					{headerContent}
				</header>
				{children}
			</div>
		</div>
	)
}

export default Layout
